<template>

  <div>

    <t-gallery :images="galleryImages" v-if="galleryShow" v-model="galleryShow" title="Imagens do Produto"/>

    <b-modal size="xl" @hide="closeSearch()" ref="modal" no-close-on-esc id="modal-product-search"
             no-close-on-backdrop
             title="Buscar Produto" hide-footer>

      <b-row>

        <t-input cols="2" v-model="form.default" :label="'Cód. '+ accountPrefix + '/Produto'"
                 @keyup.enter.native="executeSearchInput"/>


        <t-input cols="3" v-model="form.name" :label="'Produto'"
                 @keyup.enter.native="executeSearchInput"/>

        <t-input-search cols="3"
                        v-model="form.groupProductId"
                        :options="groupProductOptions"
                        @change="changeGroupProduct"
                        select label="Grupo"/>

        <!--        <t-input-search
                    cols="6"
                    :disabled="form.groupProductId === 0"
                    v-model="form.modelId"
                    :options="modelOptions"
                    @change="changeModel"
                    select label="Modelo"/>-->


        <t-input cols="2" v-model="form.code" label="Cód. Conversão"
                 help="Código cadastrado na aba Códigos de Conversão do Produto, podendo ser: Cód. do Cliente/Grupo ou Mercado"
                 @keyup.enter.native="executeSearchInput"/>


        <t-button @click="executeSearchInput" cols="2" primary form-inline>
          <b-icon-search class="mr-1" style="scale: 0.8"></b-icon-search>
          Filtrar
        </t-button>


        <!--        <t-input-search cols="2"
                                v-model="form.unitId"
                                :options="unitOptions"
                                select label="Un."/>-->

      </b-row>

      <b-row>


        <!--        <t-input-search cols="2" v-model="form.hasStock" :options="yesOrNotOptionsAndAll" label="Possui estoque"
                                select/>-->


        <!--        <b-col cols="3">

                  <t-input-code-label compound disable-name v-model="form.compoundId" />

                </b-col>-->

        <!--        <b-col cols="3">

                  <t-input-code-label material disable-name v-model="form.materialId" />

                </b-col>-->


      </b-row>

      <b-row v-if="hasConditionalFields()">

        <b-col cols="12">

          <t-page-form-field-customized
              ref="fieldsGroupProduct"
              v-if="entityFieldCustomized('groupProduct').length > 0"
              @onPressEnter="executeSearchInput"
              only-search
              big-search
              :fields-customizable="entityFieldCustomized('groupProduct')"
              :foreign-key="form.groupProductId" foreign-key-column="groupProductId"
          />


          <t-page-form-field-customized
              ref="fieldsModel"
              v-if="entityFieldCustomized('model').length > 0"
              @onPressEnter="executeSearchInput"
              only-search
              big-search
              :fields-customizable="entityFieldCustomized('model')"
              :foreign-key="form.modelId" foreign-key-column="modelId"
          />

        </b-col>

      </b-row>


      <b-row>


        <b-col cols="6">

          <b-row v-if="enableAllFilters">

            <t-input-search cols="4" v-model="form.typeExclusive"
                            label="Exclusividade" :options="ProductExclusiveType.list" select
                            required/>

            <b-col cols="8">

              <t-input-person customer
                              v-show="form.typeExclusive !== ProductExclusiveType.type.GROUP_CUSTOMER"
                              v-model="form.customerId"
                              :disabled="form.typeExclusive !== ProductExclusiveType.type.GROUP_CUSTOMER"/>


              <t-input-search v-show="form.typeExclusive === ProductExclusiveType.type.GROUP_CUSTOMER"
                              v-model="form.customerGroupId"
                              label="Grupo de Cliente"
                              :options="groupCustomerOptions" select/>

            </b-col>


          </b-row>

        </b-col>

        <b-col cols="2" v-if="hasConditionalFields()">

          <t-input v-model="form.searchMeasureRange" number decimals="3" label="Margem"
                   help="Margem padrão para pesquisar em campos marcados do tipo 'Medida'. Utilize as opções: +- (abaixo e acima), + (somente acima), - (somente abaixo). Para alterar a margem de pesquisa padrão acesse: 'Produtos > Configurações > Parâmetros">

            <template #input-group-append>

              <div class="input-group-text">

                <b-dropdown size="sm" :text="searchMeasureLabel" variant="link">
                  <b-dropdown-item-button @click="setSearchMeasureType(1)">+-</b-dropdown-item-button>
                  <b-dropdown-item-button @click="setSearchMeasureType(2)">+</b-dropdown-item-button>
                  <b-dropdown-item-button @click="setSearchMeasureType(3)">-</b-dropdown-item-button>
                </b-dropdown>


              </div>

            </template>

          </t-input>

        </b-col>

        <!--        <b-col cols="3" class="d-flex">

        &lt;!&ndash;          <t-button @click="enableAllFilters = !enableAllFilters" outline-primary form-inline>
                    <b-icon-plus/>
                    Detalhes
                  </t-button>&ndash;&gt;

                  <t-button @click="executeSearchInput" class="ml-3" primary form-inline>
                    <b-icon-search class="mr-1" style="scale: 0.8"></b-icon-search>
                    Filtrar
                  </t-button>


                </b-col>-->


      </b-row>

      <b-row class="mb-3" v-if="enableAllFilters">

        <b-col cols="12" v-if="entityFieldCustomized('page').length > 0">

          <t-page-form-field-customized
              ref="fieldsGeneral"
              @onPressEnter="executeSearchInput"
              only-search
              big-search
              :fields-customizable="entityFieldCustomized('page')"
              :foreign-key="22" primary-key-column="productId" foreign-key-column="pageId"
          />

        </b-col>


        <b-col cols="6">

          <b-row>

            <t-input-search
                cols="6"
                v-model="form.featureId"
                :options="featureOptions"
                select label="Característica"/>


            <t-input-search cols="6"
                            v-model="form.complementId"
                            :options="complementOptions"
                            select label="Acabamento"/>


          </b-row>


        </b-col>

        <b-col cols="6">

          <t-keyword v-model="form.keyword"/>

        </b-col>

      </b-row>

      <div style="overflow: hidden; position: relative; float: left; width: 100%">


        <t-table
            @getPage="getPageSearchList"
            :show="checkViewListTableDefault()"
            :filtered="filtered"
            :busy="!pageListIsLoaded"
            :user-auth="userAuth"
            :items="request.content"
            :fields="viewFieldsPageProduct"
            :total-pages="request.totalPages"
            :total-elements="request.totalElements"
            :container-table-style="[{'min-height':'250px'}]"
            title-items="Produtos"
            link-primary-column="productCodeLabel"
            table-bordered
            table-striped
            disable-actions-column
            primary-key-column="productId">

          <template #first-column="{item}">
            <b-link @click="selectItemList(item.productId)">{{ item.productCodeLabel }}</b-link>
          </template>

          <template #item(name)="{item}">
            <div v-html="highlightMeasures(item.name)"></div>
          </template>

          <template #item(firstFileName)="{item}">

            <t-button small v-if="item.firstFileName !== ''" outline-light
                      @click="openModalProductImages(item.productId)">
              <t-image-blob style="max-width: 50px;"
                            :src="'product/item-file/image/'+item.productId+'/'+item.firstFileId+'/?variant=thumbnail'"
                            class="align-self-center"/>


            </t-button>

            <small v-else>-</small>

          </template>


          <template #item(qtyImagesGeneral)="{item}">

            <t-button small @click="openModalProductImages(item.productId)">
              <b-icon-camera/>
            </t-button>

          </template>


        </t-table>

      </div>

    </b-modal>

  </div>


</template>
<script>

import pageInputSearchListMixin from "@/mixins/page/pageInputSearchListMixin";

import productService from "@/services/modules/product/Product.service";
import groupProductService from "@/services/modules/product/GroupProduct.service"
import modelService from "@/services/modules/product/Model.service"
import complementService from "@/services/modules/product/Complement.service";
import featureService from "@/services/modules/product/Feature.service"
import groupCustomerService from "@/services/modules/customer/GroupCustomer.service";
import pageViewService from "@/services/modules/setting/PageView.service";

import ui from "@/assets/scripts/ui";
import unitService from "@/services/modules/product/Unit.service";
import ProductExclusiveType from "@/model/types/modules/product/ProductExclusiveType";
import TKeyword from "@/components/template/form/input/t-keyword";
import TGallery from "@/components/template/page/t-gallery";
import VarType from "@/model/types/resource/VarType";
import tImageBlob from "@/components/template/theme/t-image-blob";


export default {
  name: 't-input-product-list',
  mixins: [pageInputSearchListMixin],
  components: {TKeyword, TGallery, tImageBlob},
  data() {
    return {
      ProductExclusiveType,
      path: "product", //Utilizar somente quando fora do padrão
      id: "modal-product-search",
      form: {
        default: "",
        groupProductId: 0,
        name: "",
        modelId: 0,
        materialId: 0,
        code: "",
        typeExclusive: 0,
        complementId: 0,
        compoundId: 0,
        featureId: 0,
        unitId: 0,
        customerId: 0,
        customerGroupId: 0,
        hasStock: '',
        searchMeasureType: 1,
        searchMeasureRange: 0.0,
        keyword: [],//Sem o s para separar a busca do objeto do formulário
      },
      accountPrefix: "",
      searchMeasureLabel: "+-",
      galleryShow: false,
      galleryImages: [],
      viewFieldsPageProduct: [],
      fieldsCustom: [],
      groupProductOptions: [],
      modelOptions: [],
      unitOptions: [],
      complementOptions: [],
      featureOptions: [],
      groupCustomerOptions: [],
      measureTypeOptions: [{value: 1, text: '+-'}, {value: 2, text: '+'}, {value: 3, text: '-'}],
      measureTextHighlight: [], //Textos das medidas personalizadas formatadas para destacar na listagem
      fieldsCustomizable: [
        {
          entity: "page",
          foreignKeyColumn: "pageId",
          path: "",
          fields: [],
        },
        {
          entity: "groupProduct",
          foreignKeyColumn: "groupProductId",
          path: "product/group-product",
          fields: [],
        },
        {
          entity: "model",
          foreignKeyColumn: "modelId",
          path: "product/model",
          fields: [],
        }
      ],
    }
  },

  methods: {

    mountedPrepare() {


      this.accountPrefix = ui.getAccountPrefix()

    },
    async mountedContinued() {

      //Campos da Listagem de Produtos (sempre pela página original, depois será verificado se há customização de campos)
      /*SEMPRE IRÁ VERIFICAR SE HOUVE OVERRIDE, POR TANTO ENVIAR A PÁGINA ORIGINAL*/
      await pageViewService.getViewFieldsByPage(22, true).then((response) => {
        this.viewFieldsPageProduct = response
      }).catch(error => this.responseError(error))

      /* await settingParamService.getParamValueByTypeAndPosition(SettingType.type.TYPE_PRODUCT_SEARCH_MEASURE_RANGE_DEFAULT).then((value) => {
         this.form.searchMeasureRange = value
       }).catch(error => this.responseError(error))*/

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))


      await complementService.selectList().then((list) => {
        this.complementOptions = list
      }).catch(error => this.responseError(error))


      await featureService.selectList("grouped").then((list) => {
        this.featureOptions = list
      }).catch(error => this.responseError(error))


      await unitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))

      await groupCustomerService.selectList().then((response) => {
        this.groupCustomerOptions = response
      }).catch(error => this.responseError(error))

      await this.getFieldsCustomizableGeneralByPageId(22)
      await this.getModelsByGroupProductId()

      this.pageListIsLoaded = true


    },

    async executeAfterSearch() {

      this.measureTextHighlight = []

      if (this.entityFieldCustomized('groupProduct').length > 0) {

        //Por enquanto implementado somente quando campos de Grupos e do tipo double
        const fields = this.entityFieldCustomized('groupProduct')

        for (const field of fields) {

          if (field.var === VarType.type.DOUBLE) {

            if (field.value > 0) {
              this.measureTextHighlight.push(ui.convertNumber(field.value, field.decimalPrecision, "pt-br", true))
            } else {
              //Marca a posição não preenchida para replace correto e destaque conforme medida
              this.measureTextHighlight.push("0")
            }

          }
        }

      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    highlightMeasures(text) {

      let textHighLight = text
      let measureTextFound = []

      //Padrões aceitos:
      //RET-0001 - 62,00 X 104,00 X 240,00 Cilindro Padrão
      //13355455 - 62,00 - 104,00 - 240,00 Cilindro Padrão
      //RET-0001 - 62,00 104,00 240,00 Cilindro Padrão
      //RET-0001 62,00 104,00 240,00 Cilindro Padrão
      //RET-0001 62,00/104,00/240,00 Cilindro Padrão
      //RET-0001 62.00/104.00/240.00 Cilindro Padrão
      //RET-0001 62.00/104.00/240.00 Cilindro Padrão

      //Condição mímina é ter pelo menos 1 espaço e ter sido informada pelo menos 1 medida válida para pesquisa
      if (text.indexOf(' ') > 0 && this.measureTextHighlight.length > 0) {

        const measures = text.substring(text.indexOf(' '));
        textHighLight = text.substring(0, text.indexOf(' ')) //Começa novamente com a primeira partte
        let position = 0 //Posição da medida encontrada
        const list = measures.split(' ')

        for (let a of list) {

          if ((a !== '' && a !== 'X' && a !== '/' && a !== '/') && (a.includes(',') || a.includes('.'))) {

            textHighLight += '<span class=text-normal-position-' + position + '>' + a + '</span>' + ' '
            position++
            measureTextFound.push(a)

          } else {
            textHighLight += a + ' '
          }

          if (position > 0) {
            //Medidas encontradas no texto

            for (let i = 0; i < this.measureTextHighlight.length; i++) {

              //Quantidade de medidas encontrass é igual ou superior a medida buscada
              if (measureTextFound.length >= i) {

                //Posição da medida encontrada com a posição da medida buscada são idênticas
                if (measureTextFound[i] === this.measureTextHighlight[i]) {
                  textHighLight = textHighLight.replace('text-normal-position-' + i, 'highlightSearched')
                }

              }

            }

          }

        }
      }

      return textHighLight
    },

    openModalProductImages(id) {

      productService.getImages(id).then((response) => {

        this.galleryShow = true
        this.galleryImages = response

      }).catch(error => this.responseError(error))


    }
    ,

    setSearchMeasureType(type) {

      this.form.searchMeasureType = type

      if (type === 1) {
        this.searchMeasureLabel = "+-"
      } else if (type === 2) {
        this.searchMeasureLabel = "+"
      } else {
        this.searchMeasureLabel = "-"
      }

    }
    ,


    hasConditionalFields() {
      return this.entityFieldCustomized('groupProduct').length > 0 || this.entityFieldCustomized('model').length > 0
    }
    ,


    async getModelsByGroupProductId() {


      if (this.form.groupProductId > 0) {

        let params = new URLSearchParams()
        params.set("status", 1)
        params.set("groupProductId", this.form.groupProductId)

        await modelService.selectList(params).then((list) => {
          this.modelOptions = list
        }).catch(error => this.responseError(error))

      }

    }
    ,


    async changeGroupProduct() {
      this.form.modelId = 0 //Zera para poder consistir o valor
      await this.getModelsByGroupProductId()
      await this.getFieldsCustomizable('groupProduct')
    }
    ,

    async changeModel() {
      await this.getFieldsCustomizable('model')
    }
    ,


    //--------------------------------------------------------------------------------------
  },


  async mounted() {

    this.mountedPrepare()

    await this.getPageSearchList(this.pageNumber, false)

    await this.mountedContinued()

  },

}
</script>